import React from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';

const ProtectedLayout = ({ children }) => {
  return (
    <Box sx={{ 
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden' // Impedir rolagem duplicada
    }}>
      <Navbar>
        {children}
      </Navbar>
    </Box>
  );
};

export default ProtectedLayout; 